/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export interface LocaleRoutes {
  acceptGift: string;
  account: string;
  sendGift: string;
  exploreMenu: string;
  signUp: string;
  signIn: string;
  storeLocator: string;
  quiz: string;
  timsForGood: string;
  userPreferencesModal: string;
  timsRewardsFaq: string;
  hockeyChallenge: string;
}

export const localeRoutes: Record<string, LocaleRoutes> = {
  ca: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  cs: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  de: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  en: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  es: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  fr: {
    acceptGift: '/accepter-un-cadeau',
    account: '/compte',
    sendGift: '/cadeau',
    exploreMenu: '/nouveaux-gouts',
    signUp: '/inscrivez-vous',
    signIn: '/connectez-vous',
    storeLocator: '/localisateur-de-magasin',
    quiz: '/quiz',
    timsForGood: '/timdubienauquotidien',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/foire-aux-questions-de-fidelitim',
    hockeyChallenge: '/defi-hockey',
  },
  ko: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  nl: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  pl: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  pt: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  ro: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  gl: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
  eu: {
    acceptGift: '/accept-gift',
    account: '/account',
    sendGift: '/gift',
    exploreMenu: '/explore-menu',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    quiz: '/quiz',
    timsForGood: '/tims-for-good',
    userPreferencesModal: '/user-preferences-modal',
    timsRewardsFaq: '/tims-rewards-faq',
    hockeyChallenge: '/hockey-challenge',
  },
};
